import {Injectable} from "@angular/core";
import {Api, ApiService} from "./api.service";
import {HelpersService} from "./helpers.service";

@Injectable()
export class TeamService {

    public constructor(private apiService: ApiService) {
    }

    public getTeams(query: any = {}): Promise<Api.IResponse> {
        return this.apiService.request(Api.EMethod.Get, ["team"], {}, query);
    }

}
